import axios from "axios";

export const BASE_URL = "api/v1/integrations";
export const BASE_URL_INTEGRATION_CONFIG = "api/v2/integration-configs";
export const BASE_URL_GOOGLE_DRIVE = `${BASE_URL}/google-drive`;
export const BASE_URL_ONEDRIVE = `${BASE_URL}/onedrive`;
export const BASE_URL_STORAGE_SYNC = `${BASE_URL}/storage`;

export function getIntegrations() {
  return axios.get(BASE_URL);
}

export function addIntegrationConfig(integrationId, data) {
  return axios.post(`${BASE_URL}/${integrationId}/add-config`, data);
}

export function updateIntegrationConfig(integrationConfigId, data) {
  return axios.patch(`${BASE_URL_INTEGRATION_CONFIG}/${integrationConfigId}`, data);
}

export function regenerateIntegrationConfig(integrationConfigId) {
  return axios.post(`${BASE_URL_INTEGRATION_CONFIG}/${integrationConfigId}/regenerate`);
}

export function activateIntegration(integrationConfigId) {
  return axios.post(`${BASE_URL}/${integrationConfigId}/activate`);
}

// --- Google Drive ---

export function getGoogleDriveOAuthUrl() {
  return axios.get(`${BASE_URL_GOOGLE_DRIVE}/oauth/start`);
}

export function getGoogleDrivePickerToken() {
  return axios.post(`${BASE_URL_GOOGLE_DRIVE}/oauth/picker-token`);
}

export function saveGoogleDriveFolder(folderId, folderName) {
  return axios.patch(`${BASE_URL_GOOGLE_DRIVE}/oauth/config`, { folderId, folderName });
}

export function validateGoogleDriveConnection() {
  return axios.get(`${BASE_URL_GOOGLE_DRIVE}/validate`);
}

export function disconnectGoogleDrive() {
  return axios.delete(`${BASE_URL_GOOGLE_DRIVE}/oauth/disconnect`);
}

export function syncGoogleDriveForProvider(providerId, requestId) {
  return axios.post(`${BASE_URL_GOOGLE_DRIVE}/sync`, { providerId, requestId });
}

// --- OneDrive ---

export function getOneDriveOAuthUrl() {
  return axios.get(`${BASE_URL_ONEDRIVE}/oauth/start`);
}

export function getOneDrivePickerToken(resource) {
  return axios.post(`${BASE_URL_ONEDRIVE}/oauth/picker-token`, resource ? { resource } : {});
}

export function saveOneDriveFolder(folderId, folderName, driveId) {
  return axios.patch(`${BASE_URL_ONEDRIVE}/oauth/config`, { folderId, folderName, driveId });
}

export function validateOneDriveConnection() {
  return axios.get(`${BASE_URL_ONEDRIVE}/validate`);
}

export function disconnectOneDrive() {
  return axios.delete(`${BASE_URL_ONEDRIVE}/oauth/disconnect`);
}

export function syncStorageProvider(providerId, requestId, provider) {
  return axios.post(`${BASE_URL_STORAGE_SYNC}/sync`, { providerId, requestId, provider });
}
